/*
 * 4–8 ("g48") Home layout. The mascot is hidden for this variant, so the
 * board uses the full stage: TodayCard headline on top, then a row of two
 * glass boxes (Turn-In + To-Do) that share the remaining height. Sizing is
 * clamp/%-based — the KioskStage scales the 1920×1080 canvas, so no media
 * queries.
 */

.board {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: clamp(16px, 2.2vh, 36px) clamp(20px, 3vw, 64px);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(14px, 1.8vh, 30px);
}

/* TodayCard sits at its natural height; the boxes take the rest. */
.headline {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  justify-content: center;
}

.boxes {
  /* Occupy the area under the headline so the boxes sit just below it, but
   * the boxes themselves only grow to their content (align-items: flex-start)
   * rather than stretching the full height — no big empty space on light days. */
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  /* px cap (not vw): inside the transform-scaled KioskStage, vw resolves
   * against the real window, not the 1920 canvas — so a % of the always-1920
   * board keeps the two boxes side-by-side at every display size. */
  max-width: 1680px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  gap: 28px;
}

/* Two equal columns. basis 40% of the 1680 board so both always fit on one
 * row; they only stack if the board itself becomes extremely narrow. Each box
 * is capped at the available height so a very long list scrolls inside its own
 * box (the live screen never scrolls) instead of overflowing the stage. */
.boxes > * {
  flex: 1 1 40%;
  min-width: 320px;
  max-height: 100%;
}
